import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getNominationJudgementCount: (
  fetchContext: FetchContext,
  nominationId: number,
  accessToken?: string,
) => Promise<number> = (fetchContext, nominationId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/nominations/${nominationId}/judgement-count`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'get nomination judgement count'));
